import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable cdcTranslations has been removed and is no longer part of the public API. 
import { cdcTranslationChunksConfig, cdcTranslationsEn } from "@spartacus/cdc/assets";
import { CdcConfig, CdcRootModule, CDC_FEATURE } from "@spartacus/cdc/root";
import { CmsConfig, ConfigModule, I18nConfig, provideConfig } from "@spartacus/core";
import { environment } from '../../../../environments/environment';

@NgModule({
  declarations: [],
  imports: [
    CdcRootModule,
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [CDC_FEATURE]: {
        module: () =>
          import('@spartacus/cdc').then((m) => m.CdcModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: cdcTranslationsEn,
      chunks: cdcTranslationChunksConfig,
    },
  }),
  provideConfig(<CdcConfig>{
    cdc: [{
      baseSite: 'seqirusb2b-flu360',
        javascriptUrl: 'https://cdns.us1.gigya.com/JS/gigya.js?apikey='+environment.CdcUskey,
        sessionExpiration: 3600
    },
    {
      baseSite: 'seqirusb2b-uk',
        javascriptUrl: 'https://cdns.eu1.gigya.com/JS/gigya.js?apikey='+environment.CdcUkKey,
        sessionExpiration: 3600
    }
      // {
      //   baseSite: 'BASE_SITE_PLACEHOLDER',
      //   javascriptUrl: 'JS_SDK_URL_PLACEHOLDER',
      //   sessionExpiration: 3600
      // },
    ],
  })
  ]
})
export class CdcFeatureModule { }
